import React from 'react';
import styles from '@/pages/task-list/styles.less';
import { Trans, useTranslation } from 'react-i18next';

const Immediate = ({ instruction = true }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tip}>
      <p>
        <b>{t('“Immediate Tasks” are tasks that:')}</b>
      </p>
      <li>
        {t(
          'Notify family, friends and (if applicable) current employers of the death.'
        )}
      </li>
      <li>
        {t(
          'Stop payments (in order to avoid overpayments that must be repaid at a later date).'
        )}
      </li>
      <li>{t('Prevent the potential of identity theft or asset theft.')}</li>
      <li>{t('Address urgent issues.')}</li>
      <li>{t('Must be completed first, in preparation for future tasks.')}</li>
      <br />
      {instruction && (
        <>
          <p>
            <b>{t('Instructions:')}</b>
          </p>
          <li>
            {t(
              'Complete Immediate Tasks in the order shown as soon as possible (i.e. within 7 days) after the death.'
            )}
          </li>
          <li>
            {t(
              'Ensure to annotate each task step in the Task Details page as “Completed” once done.'
            )}
          </li>
        </>
      )}
    </div>
  );
};

const Legal = ({ instruction = true }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tip}>
      <p>
        <b>{t('“Legal Tasks”')}</b>{' '}
        {t(
          'are tasks required to obtain or confirm the legal authority to manage or distribute an estate.'
        )}
      </p>
      <br />
      {instruction && (
        <>
          <p>
            <b>{t('Instructions:')}</b>
          </p>
          <li>
            {t(
              'Start Legal Tasks as soon as possible after Immediate Tasks have been identified and started (ideally, Legal Tasks should be started within 30 days of the date of death).'
            )}
          </li>
          <li>{t('Ensure to annotate each task step as “Completed” once done.')}</li>
        </>
      )}
    </div>
  );
};

const Main = ({ instruction = true }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tip}>
      <p>
        <b>{t('“Main Tasks” are tasks that:')}</b>
      </p>
      <li>
        {t(
          'Notify significant parties and/or agencies of the death of the decedent.'
        )}
      </li>
      <li>
        {t(
          'Apply for death benefits (from governments, employers, insurance, etc) the estate and/or survivors are entitled to.'
        )}
      </li>
      <li>
        {t(
          'Manage services (i.e. modify, transfer, cease, etc) the decedent was using prior to their death.'
        )}
      </li>
      <br />
      {instruction && (
        <>
          <p>
            <b>{t('Instructions:')}</b>
          </p>
          <li>{t('Complete Main Tasks in any order, as required.')}</li>
          <li>
            {t(
              'Ensure to annotate each task step in the Task Details page as “Completed” once done.'
            )}
          </li>
        </>
      )}
    </div>
  );
};

const Assets = ({ instruction = true }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tip}>
      <p>
        <b>{t('“Asset Tasks”')}</b>{' '}
        {t(
          'are tasks that are required to manage the assets (i.e. transfer, sell, distribute, etc) that are in the decedent’s name.'
        )}
      </p>
      <br />
      {instruction && (
        <>
          <p>
            <b>{t('Instructions:')}</b>
          </p>
          <li>{t('Complete Asset Tasks in any order, as required.')}</li>
          <li>
            <Trans
              i18nKey="Ensure to annotate each task step in the Task Details page as <1>“Completed”</1> once done."
              components={{ 1: <i /> }}
            />
          </li>
        </>
      )}
    </div>
  );
};

const Closing = ({ instruction = true }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tip}>
      <p>
        <b>{t('“Closing Tasks”')}</b>{' '}
        {t(
          'are tasks required to formally close the estate management process. They have been identified based on legal and/or administrative requirements that must be met to formally close the estate management process.'
        )}
      </p>
      <br />
      {instruction && (
        <>
          <p>
            <b>{t('Instructions:')}</b>
          </p>
          <li>{t('Complete Closing Tasks in the order shown.')}</li>
          <li>
            <Trans
              i18nKey="Ensure to annotate each task step in the Task Details page as <1>“Completed”</1> once done."
              components={{ 1: <i /> }}
            />
          </li>
        </>
      )}
    </div>
  );
};

export { Immediate, Legal, Main, Assets, Closing };
